import type { BreakType } from './types';

export const BREAK_TYPES: { value: BreakType; label: string }[] = [
  { value: 'lunch', label: 'Lunch' },
  { value: 'tea', label: 'Tea' },
  { value: 'bio', label: 'Bio' },
  { value: 'meeting', label: 'Meeting' },
];

export const BREAK_LABELS: Record<string, string> = Object.fromEntries(BREAK_TYPES.map((b) => [b.value, b.label]));

/** Human-readable duration from seconds, e.g. "1h 05m" or "45m" or "30s". */
export function formatDuration(totalSec: number): string {
  const sec = Math.max(0, Math.round(totalSec || 0));
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = sec % 60;
  if (h > 0) return `${h}h ${String(m).padStart(2, '0')}m`;
  if (m > 0) return `${m}m ${String(s).padStart(2, '0')}s`;
  return `${s}s`;
}
